import HmAjax from './HmAjax';
import UrlManager from './../model/UrlManager';

/**
* This function needs UserStore to be passed as part of the constructor to work. from LoggedInPage
*/
let AttributeManager = function(userStore){
	
	let updateToServer = function(attr_key, attr_value, callback){
		var me = this;
		var success = function(userObj){
			if(userObj){
				userStore.store(userObj);	
			}

			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var failure = function(error){
			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var attrData = {"attr_key":attr_key, "attr_value":attr_value};
		new HmAjax(UrlManager.getUrlForAction("UPDATE_ATTRIBUTE"),attrData).post(success,failure);
	}

	let removeFromServer = function(attr_key, callback){
		var me = this;
		var success = function(userObj){
			if(userObj){
				userStore.store(userObj);	
			}

			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var failure = function(error){
			if(callback && typeof callback === "function"){
				callback.apply(this);
			}
		}

		var attrData = {"attr_key":attr_key};
		new HmAjax(UrlManager.getUrlForAction("REMOVE_ATTRIBUTE"),attrData).delete(success,failure);
	}

	return {
		update:function(attr_key, attr_value, callback){
			updateToServer(attr_key, attr_value, callback);
		},
		remove: function(attr_key, callback){
			removeFromServer(attr_key, callback);
		}
	}
};

export default AttributeManager;


// WEBPACK FOOTER //
// ./src/util/AttributeManager.js